module.exports = __webpack_public_path__ + "img/money-back-guarantee-header.426fa876.svg";